export const FileIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="vuesax/bulk/document">
      <g id="document">
        <path
          id="Vector"
          opacity="0.4"
          d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19Z"
          fill={strokeColor}
        />
        <path
          id="Vector_2"
          d="M15.7999 2.21048C15.3899 1.80048 14.6799 2.08048 14.6799 2.65048V6.14048C14.6799 7.60048 15.9199 8.81048 17.4299 8.81048C18.3799 8.82048 19.6999 8.82048 20.8299 8.82048C21.3999 8.82048 21.6999 8.15048 21.2999 7.75048C19.8599 6.30048 17.2799 3.69048 15.7999 2.21048Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
